export class ShiftComment {
    comment: string;
}
